import { render, staticRenderFns } from "./DocumentPOSAgainHead.vue?vue&type=template&id=18db6d36"
import script from "./DocumentPOSAgainHead.vue?vue&type=script&lang=js"
export * from "./DocumentPOSAgainHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports